import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import {
  Header,
  Footer,
  ParticipationInfo,
  ImgGirl
} from "~/components/blocks";

import isWinnersPhase from "~/utils/isWinnersPhase";
import { useHistory } from "react-router-dom";

import bgImage from "~/assets/img/bg.png";

import {
  HeroBanner,
  ParticipantProducts,
  FAQContent,
  Calendar,
} from "~/components/sections";

import { scrollTop } from "~/utils/tools";


export default function Home() {
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "auto", opacity: 0, transition },
    enter: {
      y: "auto",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) {
      scrollTop();
    }
  }, []);

  const history = useHistory();
  const redirectWinners = isWinnersPhase();
  if (redirectWinners) {
    history.push("/vencedores");
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Home</title>
        <meta name="description" content="Promoção Bebê Johnson's" />
      </Helmet>
      <Header />
      <HeroBanner />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <div style={{ background: "#B1DBF0", display:"flex", justifyContent: "center"}} id="first-anchor">
        <ParticipationInfo />
        </div>
        <Calendar />

        <ParticipantProducts />
        <div style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover' }}>
          <FAQContent limit={12} />
        </div>
        <div>
          <ImgGirl />
        </div>
      </motion.div>
      <Footer />
    </>
  );
}
